// extracted by mini-css-extract-plugin
export default {"filename":"HistoryItemName__filename___JmLOd","youthName":"HistoryItemName__youthName___eUHuZ"};